import React, { useEffect } from "react";
import HeroSection from "./HeroSection";
import ProductDetails from "./ProductDetails";
import Benefits from "./Benefits";
import FAQSection from "./FAQSection";

import main from "../assets/cricket/main.jpg";
import img1 from "../assets/cricket/1.jpg";
import img2 from "../assets/cricket/2.jpg";
import img3 from "../assets/cricket/3.webp";

import Images from "./Images";
import { Helmet } from "react-helmet-async";

export default function CricketPracticeNets() {

       useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Cricket practice net-Sports Net installation Bengaluru ",
    url: "https://www.anssafetynets.com/cricketpracticenets",
    description:
      "We specialize in the installation of high-quality cricket practice nets and custom sports netting solutions for schools, academies, sports clubs, residential areas, and commercial facilities. Whether you need durable indoor cricket nets, weather-resistant outdoor nets, or professional-grade nets for football, volleyball, badminton, or golf – we've got you covered. Our expert team ensures precise, safe, and longlasting installations tailored to your space and sport requirements.",
    keywords: [
      "ANS Safety Nets",
      "Cricket Practice Nets",
      "Safety Nets in Bengaluru",
      "Cricket Training Nets",
      "Practice Nets by ANS Safety Nets",
      "safety nets in bengaluru",
      "ans safety nets",
      "Ans Safety Nets bengaluru",
      "Safety Nets in Bengaluru",
      "Safety Solutions",
      "Bengaluru Safety Nets",
      "balcony safety nets in bengaluru",
      "balcony safety nets",
      "pigeon safety nets in bengaluru",
      "monkey safety nets in bengaluru",
      "Ducteria Nets in bengaluru",
      "Pets Safety Nets in bengaluru",
      "Industrial Safety Nets in bengaluru",
      "Children Safety Nets in bengaluru",
      "Bird Spikes in Bengaluru",
      "Cricket Practice Nets in bengaluru",
      "Sports Nets",
      "Pigeon Safety Nets",
      "Building covering Net",
      "sports nets in bengaluru",
      "building covering nets in bengaluru",
    ],
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.anssafetynets.com",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Cricket Practice Nets",
          item: "https://www.anssafetynets.com/cricketpracticenets",
        },
      ],
    },
    publisher: {
      "@type": "Organization",
      name: "ANS Safety Nets",
      logo: {
        "@type": "ImageObject",
        url: "https://www.anssafetynets.com/logo.png",
        width: 250,
        height: 100,
      },
      contactPoint: [
        {
          "@type": "ContactPoint",
          telephone: "+91-7416116587",
          contactType: "Customer Service",
          areaServed: "IN",
          availableLanguage: ["English", "Kannada"],
        },
      ],
      sameAs: [
        "https://www.facebook.com/profile.php?id=61572534324956",
        "https://www.instagram.com/anssafetynets_bengaluru/",
      ],
    },
    mainEntity: {
      "@type": "Organization",
      name: "ANS Safety Nets",
      address: {
        "@type": "PostalAddress",
        streetAddress:
          "74/9, 5th Cross Rd, Muthyala Nagar, Bahubali Nagar, Jalahalli, Bengaluru, Karnataka 560013",
        addressLocality: "Bengaluru",
        addressRegion: "KA",
        postalCode: "560013",
        addressCountry: "IN",
      },
      service: [
        {
          "@type": "Service",
          name: "Cricket Practice Nets",
          areaServed: "Bengaluru",
        },
      ],
    },
  };

  return (
    <div>
      <Helmet>
        <title>Cricket practice net-Sports Net installation Bengaluru </title>
        <meta
          name="description"
          content="We specialize in the installation of high-quality cricket practice nets and custom sports netting solutions
for schools, academies, sports clubs, residential areas, and commercial facilities. Whether you need
durable indoor cricket nets, weather-resistant outdoor nets, or professional-grade nets for football,
volleyball, badminton, or golf – we've got you covered. Our expert team ensures precise, safe, and longlasting installations tailored to your space and sport requirements."
        />
        <meta
          name="keywords"
          content="Cricket practice nets installation
Sports netting installation services
Indoor cricket nets
Outdoor sports nets 
Affordable cricket net installation for schools
Durable sports nets for academies
Cricket net installation in Bengaluru 
Cricket net installation in Bangalore 
Sports nets near me
Custom sports nets Bengaluru 
Outdoor cricket practice nets"
        />
        <meta name="author" content="ANS Safety Nets, Bengaluru" />
        <link
          rel="canonical"
          href="https://www.anssafetynets.com/cricketpracticenets"
        />
        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      </Helmet>

      <HeroSection
        title="Cricket Practice Nets"
        description="Improve your cricket skills with our durable and reliable practice nets."
        bgColor="bg-[#263238]"
      />

      <ProductDetails
        title="Why Choose Our Cricket Practice Nets?"
        content="At ANS Safety Nets, we offer cricket practice nets that are designed to enhance your training experience while ensuring safety during practice sessions. Made from high-quality, durable materials, our cricket nets are built to withstand the impact of fast balls, providing a reliable barrier that protects players and equipment. Whether you're a beginner or a professional, our nets offer a safe environment to practice your shots, improve your skills, and build confidence. Customizable to fit different training spaces, ANS Safety Nets ensures that you can focus on improving your game without worrying about safety or interruptions. Trust us to provide the best cricket practice nets for a secure, productive training session."
        image={main}
      />
      <Images images={[img1, img2, img3]} />

      <Benefits
        benefits={[
          {
            title: "Safe Practice",
            description:
              "Practice without worrying about stray balls or accidents.",
          },
          {
            title: "Durability",
            description:
              "Made from heavy-duty materials to withstand long-term use.",
          },
          {
            title: "Easy Setup",
            description:
              "Set up your practice net in minutes and start training.",
          },
        ]}
      />

      <FAQSection
        faqs={[
          {
            question: "How durable are these nets?",
            answer:
              "Our nets are designed to withstand hundreds of hits from cricket balls.",
          },
          {
            question: "Can the nets be used outdoors?",
            answer: "Yes, they are designed for both indoor and outdoor use.",
          },
        ]}
      />
    </div>
  );
}
